import React, { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images = [], index = 0, onClose, onIndex }) {
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "ArrowLeft") onIndex?.(Math.max(0, index - 1));
      if (e.key === "ArrowRight") onIndex?.(Math.min(images.length - 1, index + 1));
    };
    window.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
    };
  }, [index, images.length, onClose, onIndex]);

  if (!images.length) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-white/95 backdrop-blur flex items-center justify-center p-6" data-testid="lightbox">
      <button
        onClick={onClose}
        data-testid="lightbox-close"
        className="absolute top-6 right-6 w-11 h-11 border border-slate-200 text-slate-800 hover:border-[#D4A437] hover:text-[#D4A437] flex items-center justify-center"
      >
        <X className="w-5 h-5" strokeWidth={1.5} />
      </button>

      <button
        onClick={() => onIndex?.(Math.max(0, index - 1))}
        disabled={index === 0}
        data-testid="lightbox-prev"
        className="absolute left-6 top-1/2 -translate-y-1/2 w-11 h-11 border border-slate-200 text-slate-800 hover:border-[#D4A437] hover:text-[#D4A437] flex items-center justify-center disabled:opacity-30"
      >
        <ChevronLeft className="w-5 h-5" strokeWidth={1.5} />
      </button>

      <img src={images[index]} alt="" className="max-h-[85vh] max-w-[90vw] object-contain" />

      <button
        onClick={() => onIndex?.(Math.min(images.length - 1, index + 1))}
        disabled={index === images.length - 1}
        data-testid="lightbox-next"
        className="absolute right-6 top-1/2 -translate-y-1/2 w-11 h-11 border border-slate-200 text-slate-800 hover:border-[#D4A437] hover:text-[#D4A437] flex items-center justify-center disabled:opacity-30"
      >
        <ChevronRight className="w-5 h-5" strokeWidth={1.5} />
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-xs tracking-[0.25em] uppercase text-slate-600">
        {index + 1} / {images.length}
      </div>
    </div>
  );
}
